import axios from "axios";
// @ts-ignore
import { getAuthConfig } from "cwb-react";

export interface IUploadPhotoResponse {
  message: string;
  errors: Array<{
    field: string;
    message: string;
  }>;
  error: boolean;
  tooLarge: boolean;
  maxNumberOfPhotosExceed: boolean;
  invalidFile: boolean;
  success: boolean;
  photoNumber: number;
  photoUrl: string;
}

export interface IAgent {
  firstName: string;
  lastName: string;
  phone: string;
  address1: string;
  address2: string;
  country: string;
  province: string;
  city: string;
  status: number;
  metroAreas: string;
}

export interface IAgency {
  agencyName: string;
  phone: string;
  address1: string;
  address2: string;
  country: string;
  province: string;
  city: string;
  status: number;
}

export interface IMultipleProfile {
  rosterId: number;
  agencyId: number;
  agentId: number;
  agent: IAgent;
  agency: IAgency;
  isSelfRepresent: boolean;
  isGhostProfile: boolean;
  defaultPhotoNumber: number;
  defaultResumeRosterId: number;
  clientId: number;
  isDefault: boolean;
  photoPermission: number;
  sidesPermission: number;
  profilePermission: number;
  resumePermission: number;
  openBDPermission: boolean;
  epitchPermission: boolean;
  castingNoticePermission: boolean;
  compCardPermission: boolean;
}

export const uploadPhoto = (clientId: string, file: File) => {
  const formData = new FormData();
  formData.append('formFile', file);

  const authConfig = getAuthConfig();

  return axios.post(
    `${process.env.REACT_APP_PM_Api}/Photo/${clientId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...authConfig.headers,
      },
    }
  );
};

export const getMultipleProfiles = (clientId: string) => {
  const authConfig = getAuthConfig();

  return axios.get<IMultipleProfile[]>(
    `${process.env.REACT_APP_PM_Api}/MultipleProfiles/${clientId}/all`,
    {
      headers: {
        ...authConfig.headers,
      },
    }
  );
};

export interface IUploadResumeResponse {
  message: string;
  errors: Array<{
    field: string;
    message: string;
  }>;
  error: boolean;
  tooLarge: boolean;
  invalidFile: boolean;
  success: boolean;
  resumeUrl?: string;
  pdfUrl?: string;
}

export const uploadResume = (clientId: string, rosterId: number, file: File, title?: string) => {
  const formData = new FormData();
  const fileName = title || file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
  
  formData.append('formFile', file);

  const authConfig = getAuthConfig();

  return axios.post<IUploadResumeResponse>(
    `${process.env.REACT_APP_PM_Api}/Resume/${clientId}/roster/${rosterId}?visibility=true&title=${encodeURIComponent(fileName)}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...authConfig.headers,
      },
    }
  );
};